import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getCompany,
  postCompany,
} from '../../data/jobs/jobActions';
import {
  createIsLoading,
  createDidError,
} from '../../data/requests/requestsSelectors';
import Modal from '../static/Modal';
import PromotionForm from "./PromotionForm";
import CompanyForm from "./CompanyForm";
import DuplicateCheck from './DuplicateCheck';

import createLogger from '../../utils/createLogger';
import {Loading} from "../static/Indicators";

const DEBUG = true;
const debug = createLogger(DEBUG, `PromotionModal.js`);


class PromotionModal extends React.Component {

  static dependencies = [
    'GET_COMPANY',
    'POST_COMPANY'
  ];

  static propTypes = {
    didError: PropTypes.bool.isRequired,
    modalIsOpen: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
  };

  /* ------------ lifecycle methods ------------ */
  static role = `modal`;
  constructor (props) {

    super (props);
    debug.enter (`constructor`);

    this.state = {
      matchUrl: '',
      matchStrategy: '',
      companyForm: false,
      duplicateCheck: false,
      companyId: null,
    }
  }

  /* ------------ event handlers ------------ */

  showAddCompany = () => {this.setState({companyForm: true, companyId: null})};
  showEditCompany = () => {this.setState({companyForm: true})};
  showDuplicateCheck = () => {this.setState({duplicateCheck: true})};
  returnToLead = (id=null) => {this.setState({
    companyForm: false,
    duplicateCheck: false,
    companyId: id,
  })};

  setCompany = (companyId) => {
    const { getCompany } = this.props;
    this.setState({companyId: companyId});
    getCompany(companyId);
  };

  closeModal = () => {
    this.props.closeModal();
    this.returnToLead();
  };

  /* ------------ render methods ------------ */

  render () {

    const {
      closeModal,
      setCompany,
      returnToLead,
      showAddCompany,
      showEditCompany,
      showDuplicateCheck,
    } = this;

    const {
      isLoading,
      didError,
      companies,
      getCompany,
      matchUrl,
      matchStrategy,
      modalIsOpen,
      selected,
      selectNext,
    } = this.props;

    const {
      companyId,
      companyForm,
      duplicateCheck,
    } = this.state;

    return (
      <Modal title={companyForm ?
        (companyId ? "Edit Company" : "Add Company")
        : duplicateCheck ? "Duplicate Check" : "Promote Lead"}
             className={'full-screen'}
             isOpen={modalIsOpen}
             close={closeModal}
             closeButton>
        {
          companyForm ? (
            <CompanyForm closeModal={closeModal}
                         setCompany={setCompany}
                         returnToLead={returnToLead}
                         companyId={companyId ? companyId : null}/>
          ) : duplicateCheck ? (
            <DuplicateCheck id={selected}
                            matchUrl={matchUrl}
                            companyId={companyId}
                            closeModal={closeModal}
                            selectNext={selectNext}
                            returnToLead={returnToLead}/>
          ) : selected ? (
            <PromotionForm id={selected}
                           matchUrl={matchUrl}
                           companies={companies}
                           companyId={companyId}
                           isLoading={isLoading}
                           closeModal={closeModal}
                           getCompany={getCompany}
                           selectNext={selectNext}
                           setCompany={setCompany}
                           addCompany={showAddCompany}
                           matchStrategy={matchStrategy}
                           editCompany={showEditCompany}
                           duplicateCheck={showDuplicateCheck}/>
          ) : <div/>
        }
      </Modal>
    )
  }
}



const mapStateToProps = (state) => {
  const isLoading = createIsLoading(PromotionModal.dependencies);
  const didError = createDidError(PromotionModal.dependencies);

  return {
    isLoading: isLoading(state),
    didError: didError(state),
  }
};

export default connect(mapStateToProps, {
  postCompany,
  getCompany,
})(PromotionModal);



// WEBPACK FOOTER //
// ./src/components/AgencyPostings/PromotionModal.js